import { PositionGrid } from '../../../../interfaces/Position/Position'
import { HeadCell } from '../../../UI/Table/TableHeader'

interface PositionHeadCell extends PositionGrid {
  actions: string
}

export const headCells: HeadCell<PositionHeadCell>[] = [
  {
    id: 'warehouse',
    numeric: false,
    disablePadding: true,
    label: 'ALMACÉN',
    sortable: true,
    visible: true
  },
  {
    id: 'positionName',
    numeric: false,
    disablePadding: true,
    label: 'NOMBRE',
    sortable: true,
    visible: true
  },
  {
    id: 'zone',
    numeric: false,
    disablePadding: false,
    label: 'ZONA',
    sortable: true,
    visible: true
  },
  {
    id: 'subZone',
    numeric: false,
    disablePadding: true,
    label: 'SUBZONA',
    sortable: true,
    visible: true
  },
  {
    id: 'typePosition',
    numeric: false,
    disablePadding: true,
    label: 'TIPO POSICIÓN',
    sortable: false,
    visible: true
  },
  {
    id: 'active',
    numeric: false,
    disablePadding: true,
    label: 'ESTADO',
    sortable: true,
    visible: true
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: true,
    label: 'ACCIÓN',
    sortable: false,
    visible: true
  }
]
